import React from "react";
import { Invoice } from "../../interfaces/screens/billing";
import { FormBuilder } from "../form/FormBuilder";
import CurrencyDisplay from "../currencyDisplay";
import { ModalType } from "../../shared/utils/enums";
import { showModal, hideModal } from "../../connected-components/modal/reducer";
import { store } from "../../redux/store";

interface PaymentModalProps {
  invoice: Invoice;
}

// This is now a helper function, not a component.
// The modal content will be dispatched to the Redux modal state.
export const showPaymentModal = (
  invoice: Invoice,
  onSubmit: (paymentData: any) => void,
) => {
  const paymentFormSchema: { type: "object"; properties: Record<string, any> } =
    {
      type: "object",
      properties: {
        payment_date: {
          label: "Payment Date",
          component: "DatePickerField",
          required: true,
          defaultValue: new Date().toISOString().split("T")[0],
        },
        amount: {
          label: "Amount",
          component: "InputField",
          componentProps: { type: "number" },
          required: true,
        },
        currency_paid: {
          label: "Currency",
          component: "SelectField",
          required: true,
          defaultValue: "USD",
          options: [
            { value: "USD", label: "USD" },
            { value: "LBP", label: "LBP" },
            { value: "EUR", label: "EUR" },
          ],
        },
        payment_method: {
          label: "Payment Method",
          component: "SelectField",
          required: true,
          options: [
            { value: "cash_usd", label: "Cash (USD)" },
            { value: "cash_lbp", label: "Cash (LBP)" },
            { value: "card_usd_fresh", label: "Card (Fresh USD)" },
            { value: "card_usd_lollar", label: "Card (Lollar USD)" },
            { value: "card_lbp", label: "Card (LBP)" },
            { value: "bank_transfer", label: "Bank Transfer" },
            { value: "check_usd", label: "Check (USD)" },
            { value: "check_lbp", label: "Check (LBP)" },
            { value: "mobile_money", label: "Mobile Money" },
            { value: "insurance_coverage", label: "Insurance Coverage" },
          ],
        },
        reference_number: {
          label: "Reference #",
          component: "InputField",
          componentProps: { type: "text" },
        },
        exchange_rate_at_payment: {
          label: "Exchange Rate at Payment (LBP/USD)",
          component: "InputField",
          componentProps: {
            type: "number",
            min: 0,
            step: 0.01,
          },
          defaultValue: 90000,
        },
        bank_name: {
          label: "Bank Name",
          component: "InputField",
          componentProps: { type: "text" },
          showWhen: (values: any) => values.payment_method === "bank_transfer",
        },
        check_number: {
          label: "Check Number",
          component: "InputField",
          componentProps: { type: "text" },
          showWhen: (values: any) => values.payment_method?.includes("check"),
        },
        mobile_provider: {
          label: "Mobile Provider",
          component: "SelectField",
          options: [
            { value: "touch", label: "Touch" },
            { value: "alfa", label: "Alfa" },
            { value: "mtc", label: "MTC" },
            { value: "ooredoo", label: "Ooredoo" },
          ],
          showWhen: (values: any) => values.payment_method === "mobile_money",
        },
      },
    };

  const ModalContent = () => (
    <div>
      <p>
        <strong>Invoice Balance:</strong>{" "}
        <CurrencyDisplay amount={invoice.balance_due} currency={"USD"} />
      </p>
      <FormBuilder
        schema={paymentFormSchema}
        onSubmit={(data) => {
          onSubmit(data);
          store.dispatch(hideModal());
        }}
      />
    </div>
  );

  store.dispatch(
    showModal({
      title: `Add Payment for Invoice ${invoice.invoice_number}`,
      type: ModalType.COMPONENT,
      component: <ModalContent />,
    }),
  );
};
